var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatNew = function SvgWhatNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    clipPath: "url(#what_new_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.656 5.362a.486.486 0 0 1 .853 0l1.406 2.57a5.83 5.83 0 0 0 2.319 2.32l2.569 1.404a.486.486 0 0 1 0 .853l-2.57 1.406a5.83 5.83 0 0 0-2.318 2.319l-1.405 2.569a.486.486 0 0 1-.854 0l-1.405-2.57a5.83 5.83 0 0 0-2.319-2.318l-2.57-1.405a.486.486 0 0 1 0-.854l2.57-1.405a5.83 5.83 0 0 0 2.32-2.319zM4.008 1.084a.417.417 0 0 1 .731 0l.683 1.248c.23.42.574.764.994.994l1.248.683a.417.417 0 0 1 0 .73l-1.249.683a2.5 2.5 0 0 0-.994.994L4.74 7.664a.417.417 0 0 1-.731 0l-.682-1.249a2.5 2.5 0 0 0-.994-.994L1.084 4.74a.417.417 0 0 1 0-.731l1.248-.682a2.5 2.5 0 0 0 .994-.994z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "what_new_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgWhatNew;